module.exports = __webpack_public_path__ + "img/b2c-img-ig_growth.d56af83e.png";